import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import BatteryFormWorkSpace from './workspaces/BatteryFormWorkSpace';
import generateStore from './states/generateStore';

import { ThemeProvider } from '@material-ui/core/styles';
import { PeBatteryTheme } from './themes/PeBatteryTheme';


import Login from './workspaces/Login';

import './assets/css/common.css';
import { HashRouter as Router, 
    Switch, 
    Route } from 'react-router-dom';


ReactDOM.render(
    <Provider store={generateStore()}>
        <ThemeProvider theme={PeBatteryTheme}>
            <Router>
                <Switch>
                    <Route exact path="/" component={BatteryFormWorkSpace}></Route>
                    <Route path="/master" component={BatteryFormWorkSpace}></Route>
                    <Route path="/login" component={Login}></Route>
                </Switch>
            </Router>
        </ThemeProvider>
    </Provider>
    ,
    document.getElementById('root'),
)


